export default "__VITE_ASSET__lcpWoJ0R__"